import { atom } from 'jotai';
import { atomWithMutation, atomWithQuery } from 'jotai-tanstack-query';
import {
  getHintAddOnDetail,
  requestHintAddOnPayment,
  updateRenewalHintAddOn,
} from '@services/GeniebookAPI/HintPaymentServices';
import { SLOW_DATA_STALE_TIME_IN_SECONDS } from '@utils/constants/global.constants';
import { selectedSubjectIdAtom } from '@components/subscription/store/SubscriptionAtoms';
import moment from 'moment';

export const hintAddOnQueryAtom = atomWithQuery(get => {
  const subjectId = get(selectedSubjectIdAtom);
  return {
    queryKey: ['hint-add-on-detail', subjectId],
    queryFn: async () =>
      await getHintAddOnDetail({
        subject_id: Number(subjectId),
      }),
    staleTime: SLOW_DATA_STALE_TIME_IN_SECONDS,
    enabled: !!subjectId,
  };
});

export const hintDetailAtom = atom(get => {
  const query = get(hintAddOnQueryAtom);
  if (
    query.data?.data.data &&
    query.data.data.data.student_subscription_add_on_id !== undefined
  ) {
    return query.data.data.data;
  }
});

export const haveHintSubsAtom = atom(get => {
  return !!get(hintDetailAtom)?.student_subscription_add_on_id;
});

export const isHintTrialAtom = atom(get => {
  return !!get(hintDetailAtom)?.is_trial;
});

export const shouldSubscribeHintAtom = atom(get => {
  return !get(haveHintSubsAtom) || get(isHintTrialAtom);
});

export const isHintSubsRecurringAtom = atom(get => {
  const detail = get(hintDetailAtom);
  if (!detail) {
    return false;
  }

  return detail.auto_renewal == 1;
});

export const updateRenewalAtom = atomWithMutation(get => {
  const detail = get(hintDetailAtom);
  return {
    mutationFn: async (status: boolean) =>
      await updateRenewalHintAddOn({
        student_subscription_add_on_id: Number(
          detail?.student_subscription_add_on_id,
        ),
        auto_renewal_new_status: status ? 1 : 0,
      }),
  };
});

export const requestPaymentAtom = atomWithMutation(get => {
  const subjectId = get(selectedSubjectIdAtom);
  return {
    mutationFn: async () => {
      return await requestHintAddOnPayment({
        subject_id: Number(subjectId),
      });
    },
  };
});

export const hintExpiryDateAtom = atom<moment.Moment | null>(get => {
  const detail = get(hintDetailAtom);

  if (!detail) {
    return null;
  }

  // subtract by 8 (SGT to UTC) and then convert them to local time
  return moment.utc(detail.expiry_date).subtract(8, 'hours').local();
});
